<template lang="pug">
  .container-fluid
      div#fqa(v-on:click='isOpen=!isOpen')
        p &#63;

      #frequents(v-if="this.isOpen")
        h2(style='float: left;') Preguntas Frecuentes
        p#closeModal(style='text-align: right; float: right;' v-on:click='isOpen=false') &#10006;
        br
        hr(style='width: 100%;')
        h3(style='margin-top: 15px;') &iquest;Cu&aacute;l es el siguiente paso despu&eacute;s de realizar el apartado de la casa?
        p En un lapso no mayor a 24 horas un asesor de ventas se pondr&aacute; en contacto contigo para indicarte cu&aacute;les son los pasos a seguir para que estrenes tu casa.
        h3(style='margin-top: 15px;') &iquest;Qu&eacute; pasa con mi apartado si no se autoriza el cr&eacute;dito con la instituci&oacute;n financiera?
        p En caso que no se autorizara tu cr&eacute;dito, se realizar&aacute; el reembolso de tu apartado en un lapso de 30 d&iacute;as h&aacute;biles.
        h3(style='margin-top: 15px;') &iquest;Puedo realizar un cambio de modelo o ubicaci&oacute;n, aunque ya haya realizado un apartado?
        p Si es posible, este movimiento lo podr&aacute;s realizar con tu asesor de ventas.
        h3(style='margin-top: 15px;') &iquest;Qu&eacute; tipos de cr&eacute;dito son aceptados?
        p Bancario, Cofinavit, Infonavit, Fovissste, Alia2.
        h3(style='margin-top: 15px;') En caso de no querer continuar con el proceso de compra &iquest;qu&eacute; debo hacer?
        p Deber&aacute;s informar a tu asesor de venta para que te indique los pasos a seguir.

      img(v-if="this.loading" src='./cargando.gif' style="border-radius: 5%; position: absolute; width: 40%; margin-left: 20%; z-index: 20; margin-top: 10%;")
      h1#title.house-item ¡Registra tus datos para apartar tu casa!
      vm-row.heading(vm-w="12")
        vm-col#houseData( vm-align="center" vm-lg=6 vm-sm=12 vm-h="100%")
          vm-row(vm-w="12")
            vm-card
              vm-col.photo(vm-align="center" vm-lg=6 vm-sm=12 vm-h="100%")
                vm-row(vm-w="12")
                  img.img( v-if="lot.lot.category.image === null" src='https://point.bangbangeducation.ru/img/g-YBnPQla0ItoycMwR4nwqUARTbrqtP6reOPvymSHGo/fill/746/560/ce/1/bG9jYWw6Ly9zdG9y/ZS8zZDQ0MjY1YmRi/NzlkZDQ5Yjc0ZjUw/MzY4NzU4ZDcwNzcy/NWVkNzc5MDUxODBk/NjkwNTEwZjA5NmRi/NGM.png' style='width: 100%; height: 100%')
                  img.img( :src='lot.lot.category.image' style='width: 100%; height: 100%')
              vm-col.data(vm-align="center" vm-lg=6 vm-sm=12 vm-h="100%")
                vm-row(vm-w="12" vm-align="center")
                  p.house-item.reserve
                    strong Apartado
                hr
                vm-row(vm-w="12" style="margin-top: 15px")
                  p.house-item
                    strong Fraccionamiento:
                    br
                    | {{lot.map.title}}
                  br
                vm-row(vm-w="12" style="margin-top: 10px")
                  p.house-item
                    strong Casa:
                    br
                    | {{lot.lot.title}}
                  br
                vm-row(vm-w="12" style="margin-top: 10px")
                  p.house-item
                    strong Modelo:
                    br
                    | {{lot.lot.category_name}}
                  br
                vm-row(vm-w="12" style="margin-top: 10px")
                  p.house-item
                    strong Fecha estimada de terminaci&oacute;n
                    br
                    | {{lot.lot.completion_date}}
                  br
                vm-row(vm-w="12" style="margin-top: 10px")
                  p.cost
                    strong Costo de apartado:
                    br
                    | ${{lot.prices.reservation_price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString()}} MXN
                  br
          //- vm-row(vm-w="12")
            //- vm-card(style="padding: 5px 10%;")
            //- vm-row(vm-w="12")
            p(style="text-align: center; color: #4a4a4a; width: 100%;")
              strong NOTA:
              | Algunos bancos solo permiten compras en l&iacute;nea utilizando tu tarjeta digital.

        vm-col#payment(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=12 vm-h="100%")
          div.container-card
            #app.wrapper
              .card-form
                .card-list
                  .card-item(v-bind:class="{ '-active' : isCardFlipped }")
                    .card-item__side.-front
                      .card-item__focus(v-bind:class="{'-active' : focusElementStyle }" v-bind:style='focusElementStyle' ref='focusElement')
                      .card-item__cover
                        img.card-item__bg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + currentCardBackground + '.jpeg'")
                      .card-item__wrapper
                        .card-item__top
                          img.card-item__chip(src='https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png')
                          .card-item__type
                            transition(name='slide-fade-up')
                              img.card-item__typeImg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + getCardType + '.png'" v-if='getCardType' v-bind:key='getCardType' alt='')
                        label.card-item__number(for='cardNumber' ref='cardNumber')
                          template(v-if="getCardType === 'amex'")
                            span(v-for='(n, $index) in amexCardMask' :key='$index')
                              transition(name='slide-fade-up')
                                .card-item__numberItem(v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''")
                                  | *
                                .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" :key='$index' v-else-if='cardNumber.length > $index')
                                  | {{cardNumber[$index]}}
                                .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" v-else='' :key='$index + 1')
                                  | {{n}}
                          template(v-else='')
                            span(v-for='(n, $index) in otherCardMask' :key='$index')
                              transition(name='slide-fade-up')
                                .card-item__numberItem(v-if="$index > 4 && $index < 15 && cardNumber.length > $index && n.trim() !== ''")
                                  | *
                                .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" :key='$index' v-else-if='cardNumber.length > $index')
                                  | {{cardNumber[$index]}}
                                .card-item__numberItem(:class="{ '-active' : n.trim() === '' }" v-else='' :key='$index + 1')
                                  | {{n}}
                        .card-item__content
                          label.card-item__info(for='cardName' ref='cardName')
                            .card-item__holder Card Holder
                            transition(name='slide-fade-up')
                              .card-item__name(v-if='cardName.length' key='1')
                                transition-group(name='slide-fade-right')
                                  span.card-item__nameItem(v-for="(n, $index) in cardName.replace(/\s\s+/g, ' ')" v-if='$index === $index' v-bind:key='$index + 1') {{n}}
                              .card-item__name(v-else='' key='2') Full Name
                          .card-item__date(ref='cardDate')
                            label.card-item__dateTitle(for='cardMonth') Expires
                            label.card-item__dateItem(for='cardMonth')
                              transition(name='slide-fade-up')
                                span(v-if='cardMonth' v-bind:key='cardMonth') {{cardMonth}}
                                span(v-else='' key='2') MM
                            |                                     /
                            label.card-item__dateItem(for='cardYear')
                              transition(name='slide-fade-up')
                                span(v-if='cardYear' v-bind:key='cardYear') {{String(cardYear).slice(2,4)}}
                                span(v-else='' key='2') YY
                    .card-item__side.-back
                      .card-item__cover
                        img.card-item__bg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + currentCardBackground + '.jpeg'")
                      .card-item__band
                      .card-item__cvv
                        .card-item__cvvTitle CVV
                        .card-item__cvvBand
                          span(v-for='(n, $index) in cardCvv' :key='$index')
                            | *
                        .card-item__type
                          img.card-item__typeImg(v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + getCardType + '.png'" v-if='getCardType')
                .card-form__inner
                  .card-input
                    label.card-input__label(for='cardNumber') Card Number
                    input#cardNumber.card-input__input(type='text' v-mask='generateCardNumberMask' v-model='cardNumber' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardNumber' autocomplete='off')
                  .card-input
                    label.card-input__label(for='cardName') Card Holder
                    input#cardName.card-input__input(type='text' v-model='cardName' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardName' autocomplete='off')
                  .card-form__row
                    .card-form__col
                      .card-form__group
                        label.card-input__label(for='cardMonth') Expiration Date
                        select#cardMonth.card-input__input.-select(v-model='cardMonth' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardDate')
                          option(value='' disabled='' selected='') Month
                          option(v-bind:value="n < 10 ? '0' + n : n" v-for='n in 12' v-bind:disabled='n < minCardMonth' v-bind:key='n')
                            | {{n &lt; 10 ? &apos;0&apos; + n : n}}
                        select#cardYear.card-input__input.-select(v-model='cardYear' v-on:focus='focusInput' v-on:blur='blurInput' data-ref='cardDate')
                          option(value='' disabled='' selected='') Year
                          option(v-bind:value='$index + minCardYear' v-for='(n, $index) in 12' v-bind:key='n')
                            | {{$index + minCardYear}}
                    .card-form__col.-cvv
                      .card-input
                        label.card-input__label(for='cardCvv') CVV
                        input#cardCvv.card-input__input(type='text' v-mask="'####'" maxlength='3' v-model='cardCvv' v-on:focus='flipCard(true)' v-on:blur='flipCard(false)' autocomplete='off')
                  button.card-form__button(v-on:click='pay' :disabled="loading || !cardMonth || !cardYear || !cardName || !cardNumber || !cardCvv")
                    | APARTAR
                  p(style="text-align: center; color: #4a4a4a; width: 100%; margin-top: 15px;")
                    strong NOTA:
                    | Algunos bancos solo permiten compras en l&iacute;nea utilizando tu tarjeta digital.
</template>
<script>
import BaseAuth from '@/components/BaseAuth.vue'
import TheHeader from '@/components/TheHeader.vue'
import TheMenu from '@/components/TheMenu.vue'
import TheNotifications from '@/components/TheNotifications.vue'
import ModalFeedback from '@/components/aditionals/ModalFeedback.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Payments')

export default {
  name: 'payment',
  components: {
    BaseAuth,
    TheHeader,
    TheMenu,
    ModalFeedback,
    TheNotifications
  },
  data () {
    return {
      currentCardBackground: Math.floor(Math.random() * 25 + 1), // just for fun :D
      cardName: '',
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCvv: '',
      minCardYear: new Date().getFullYear(),
      amexCardMask: '#### ###### #####',
      otherCardMask: '#### #### #### ####',
      cardNumberTemp: '',
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false,
      tokenParams: {},
      key: '',
      loading: false,
      isOpen: false
    }
  },
  async created () {
    // localStorage.setItem('map_id',5);
    let str = localStorage.getItem('map_id')
    // let num = parseInt(str.slice(1,-1));
    // await this.getReservation(this.$route.params.id)
    await this.getReservation(parseInt(str))
  },
  methods: {
    ...mapActions([
      'loadData',
      'loadReservingLot',
      'setAcceptAlert',
      'closeNotifications',
      'showError',
      'payment',
      'hideModal'
    ]),
    async getReservation (id) {
      this.loadReservingLot(id)
    },
    async successHandler (token) {
      var lot = {
        map: this.lot.map.title,
        category: this.lot.lot.category_name,
        price: this.lot.prices.reservation_price,
        lot: this.lot.lot.title,
        lot_id: this.lot.lot.id
      }
      await this.payment({ ...this.tokenParams, tokenized_card: token, lot })
      this.loading = false
      if (this.paymentSuccess) {
        setTimeout(() => {
          localStorage.clear()
          window.location.replace('https://vivanza.com.mx')
        }, 5000)
      }
      return token
    },
    errorHandler: function (err) {
      this.showError(err)
      this.loading = false
      return err
    },
    closeModal () {
      localStorage.clear()
      window.location.replace('https://vivanza.com.mx')
    },
    pay () {
      this.loading = true
      if (this.lot.lot.map_id === 1 || this.lot.lot.map_id === 4 || this.lot.lot.map_id === 6) {
        this.key = 'key_SspZ1swLtfQr8TJJQtthDGQ'
      } else if ((this.lot.lot.map_id === 2 || this.lot.lot.map_id === 3 || this.lot.lot.map_id === 5 || this.lot.lot.map_id === 7)) {
        this.key = 'key_ftAgoQycq6wwccaHTpxysnQ'
      }
      window.Conekta.setPublicKey(this.key)
      this.tokenParams = {
        card: {
          name: this.cardName,
          number: this.cardNumber,
          exp_month: this.cardMonth,
          exp_year: this.cardYear,
          cvc: this.cardCvv
        }
      }
      window.Conekta.Token.create(this.tokenParams, this.successHandler, this.errorHandler)
    },
    changeLocale (locale) {
      this.$i18n.set(locale)
    },
    flipCard (status) {
      this.isCardFlipped = status
    },
    focusInput (e) {
      this.isInputFocused = true
      let targetRef = e.target.dataset.ref
      let target = this.$refs[targetRef]
      this.focusElementStyle = {
        width: `${target.offsetWidth}px`,
        height: `${target.offsetHeight}px`,
        transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
      }
    },
    blurInput () {
      let vm = this
      setTimeout(() => {
        if (!vm.isInputFocused) {
          vm.focusElementStyle = null
        }
      }, 300)
      vm.isInputFocused = false
    }
  },
  mounted () {
    this.cardNumberTemp = this.otherCardMask
    document.getElementById('cardNumber').focus()
    const script = document.createElement('script')
    script.src = 'https://cdn.conekta.io/js/latest/conekta.js'
    script.async = true
    document.body.appendChild(script)
  },
  computed: {
    ...mapGetters([
      'lot',
      'paymentSuccess',
      'errorPaymentMessage'
    ]),
    getCardType () {
      let number = this.cardNumber
      let re = new RegExp('^4')
      if (number.match(re) != null) return 'visa'

      re = new RegExp('^(34|37)')
      if (number.match(re) != null) return 'amex'

      re = new RegExp('^5[1-5]')
      if (number.match(re) != null) return 'mastercard'

      re = new RegExp('^6011')
      if (number.match(re) != null) return 'discover'

      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return 'visa' // default type
    },
    generateCardNumberMask () {
      return this.getCardType === 'amex'
        ? this.amexCardMask
        : this.otherCardMask
    },
    minCardMonth () {
      if (this.cardYear === this.minCardYear) { return new Date().getMonth() + 1 }
    }
  },
  watch: {
    cardYear () {
      if (this.cardMonth < this.minCardMonth) {
        this.cardMonth = ''
      }
    }
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:400,500,600,700|Source+Sans+Pro:400,600,700&display=swap");
body {
  background: #ddeefc;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
}

* {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

*:focus {
  outline: none;
}
#frequents {
  position: absolute;
  background-color: #fff;
  padding: 2%;
  z-index: 20;
  width: 50%;
  margin-left: 20%;
  margin-top: 10%;
  border-radius: 18px;
  /* -webkit-box-shadow: 0px 0px 23px 6px rgba(0,0,0,0.34); */
  -moz-box-shadow: 0px 0px 23px 6px rgba(0,0,0,0.34);
  box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.34);
}
#fqa {
  background-color: #a4a5a6;
  border-radius: 50%;
  position: absolute;
  margin-left: 85%;
  height: 40px;
  width: 40px;
}

#fqa:hover{
  cursor: pointer;
}

#fqa p {
  margin-left: 37%;
  color: #fff;
  font-size: 25px;
  font-weight: bold;
}

#closeModal:hover {
  cursor: pointer;
}

.wrapper {
  min-height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 50px 15px;
}

@media screen and (max-width: 700px), (max-height: 500px) {
  .wrapper {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.payment-card {
  border-radius: 15px;
  background: white;
  z-index: 100;
  max-width: 600px;
  max-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  padding: 30px;
}

.payment-card a {
  padding: 5px 30px;
  cursor: pointer;
}

.success-gif {
  max-width: 150px;
}

.failed-gif {
  max-width: 150px;
}

.payment-message {
  font-size: 18px;
}

.payment-modal {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-form {
  max-width: 570px;
  /* margin: auto; */
  width: 100%;
  /* padding-top: 10%; */
}

#payment {
  height: fit-content;
}

@media screen and (max-width: 576px) {
  .card-form {
    margin: 0 auto;
  }
  .card-item {
    width: 100% !important;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.card-form__inner {
  background: #fff;
  -webkit-box-shadow: 0 30px 60px 0 rgba(90, 116, 148, 0.4);
          box-shadow: 0 30px 60px 0 rgba(90, 116, 148, 0.4);
  border-radius: 10px;
  padding: 35px;
  padding-top: 180px;
}

@media screen and (max-width: 480px) {
  .card-form__inner {
    padding: 25px;
    padding-top: 165px;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

@media screen and (max-width: 900px) {
  #houseData {
    margin-top: 0px !important;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

@media screen and (max-width: 360px) {
  .card-form__inner {
    padding: 15px;
    padding-top: 165px;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.card-form__row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

@media screen and (max-width: 480px) {
  .card-form__row {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.card-form__col {
  -webkit-box-flex: 1;
      -ms-flex: auto;
          flex: auto;
  margin-right: 35px;
}

.card-form__col:last-child {
  margin-right: 0;
}

@media screen and (max-width: 480px) {
  .card-form__col {
    margin-right: 0;
    -webkit-box-flex: unset;
        -ms-flex: unset;
            flex: unset;
    width: 100%;
    margin-bottom: 20px;
  }
  .card-form__col:last-child {
    margin-bottom: 0;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.card-form__col.-cvv {
  max-width: 150px;
}

@media screen and (max-width: 480px) {
  .card-form__col.-cvv {
    max-width: initial;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.card-form__group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.card-form__group .card-input__input {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  margin-right: 15px;
}

.card-form__group .card-input__input:last-child {
  margin-right: 0;
}

.card-form__button {
  width: 100%;
  height: 55px;
  background: #2364d2;
  border: none;
  border-radius: 5px;
  font-size: 22px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  -webkit-box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
          box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
  color: #fff;
  margin-top: 20px;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-form__button {
    margin-top: 10px;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.card-item {
  max-width: 430px;
  height: 270px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item {
    max-width: 310px;
    height: 220px;
    width: 90%;
    /* width: 112%; */
    /* margin-left: -5%; */
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

@media screen and (max-width: 360px) {
  .card-item {
    height: 180px;
  }
  #frequents {
    width: 98% !important;
    margin-left: 0 !important;
    margin-top: 10% !important;
  }
}

.card-item.-active .card-item__side.-front {
  -webkit-transform: perspective(1000px) rotateY(180deg) rotateX(0deg) rotateZ(0deg);
          transform: perspective(1000px) rotateY(180deg) rotateX(0deg) rotateZ(0deg);
}

.card-item.-active .card-item__side.-back {
  -webkit-transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
          transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
}

.card-item__focus {
  position: absolute;
  z-index: 3;
  border-radius: 5px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.65);
}

.card-item__focus:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #08142f;
  height: 100%;
  border-radius: 5px;
  -webkit-filter: blur(25px);
          filter: blur(25px);
  opacity: 0.5;
}

.card-item__focus.-active {
  opacity: 1;
}

.card-item__side {
  border-radius: 15px;
  overflow: hidden;
  -webkit-box-shadow: 0 20px 60px 0 rgba(14, 42, 90, 0.55);
          box-shadow: 0 20px 60px 0 rgba(14, 42, 90, 0.55);
  -webkit-transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
          transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
  -webkit-transform-style: preserve-3d;
          transform-style: preserve-3d;
  -webkit-transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  height: 100%;
}

.card-item__side.-back {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  -webkit-transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
          transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
  z-index: 2;
  padding: 0;
  height: 100%;
}

.card-item__side.-back .card-item__cover {
  -webkit-transform: rotateY(-180deg);
          transform: rotateY(-180deg);
}

.card-item__bg {
  max-width: 100%;
  display: block;
  max-height: 100%;
  height: 100%;
  width: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}

.card-item__cover {
  height: 100%;
  background-color: #1c1d27;
  position: absolute;
  height: 100%;
  background-color: #1c1d27;
  left: 0;
  top: 0;
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
}

.card-item__cover:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(6, 2, 29, 0.45);
}

.card-item__top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 40px;
  padding: 0 10px;
}

@media screen and (max-width: 480px) {
  .card-item__top {
    margin-bottom: 25px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__top {
    margin-bottom: 15px;
  }
}

.card-item__chip {
  width: 60px;
}

@media screen and (max-width: 480px) {
  .card-item__chip {
    width: 50px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__chip {
    width: 40px;
  }
}

.card-item__type {
  height: 45px;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  max-width: 100px;
  margin-left: auto;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item__type {
    height: 40px;
    max-width: 90px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__type {
    height: 30px;
  }
}

.card-item__typeImg {
  max-width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  max-height: 100%;
  -o-object-position: top right;
     object-position: top right;
}

.card-item__info {
  color: #fff;
  width: 100%;
  max-width: calc(100% - 85px);
  padding: 10px 15px;
  font-weight: 500;
  display: block;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__info {
    padding: 10px;
  }
}

.card-item__holder {
  opacity: 0.7;
  font-size: 13px;
  margin-bottom: 6px;
}

@media screen and (max-width: 480px) {
  .card-item__holder {
    font-size: 12px;
    margin-bottom: 5px;
  }
}

.card-item__wrapper {
  font-family: "Source Code Pro", monospace;
  padding: 25px 15px;
  position: relative;
  z-index: 4;
  height: 100%;
  text-shadow: 7px 6px 10px rgba(14, 42, 90, 0.8);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

@media screen and (max-width: 480px) {
  .card-item__wrapper {
    padding: 20px 10px;
  }
}

.card-item__name {
  font-size: 18px;
  line-height: 1;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

@media screen and (max-width: 480px) {
  .card-item__name {
    font-size: 16px;
  }
}

.card-item__nameItem {
  display: inline-block;
  min-width: 8px;
  position: relative;
}

.card-item__number {
  font-weight: 500;
  line-height: 1;
  color: #fff;
  font-size: 27px;
  margin-bottom: 35px;
  display: inline-block;
  padding: 10px 15px;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__number {
    font-size: 21px;
    margin-bottom: 15px;
    padding: 10px 10px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__number {
    font-size: 19px;
    margin-bottom: 10px;
    padding: 10px 10px;
  }
}

.card-item__numberItem {
  width: 16px;
  display: inline-block;
}

.card-item__numberItem.-active {
  width: 30px;
}

@media screen and (max-width: 480px) {
  .card-item__numberItem {
    width: 13px;
  }
  .card-item__numberItem.-active {
    width: 16px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__numberItem {
    width: 12px;
  }
  .card-item__numberItem.-active {
    width: 8px;
  }
}

.card-item__content {
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.card-item__date {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  font-size: 18px;
  margin-left: auto;
  padding: 10px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: 80px;
  white-space: nowrap;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .card-item__date {
    font-size: 16px;
  }
}

.card-item__dateItem {
  position: relative;
}

.card-item__dateItem span {
  width: 22px;
  display: inline-block;
}

.card-item__dateTitle {
  opacity: 0.7;
  font-size: 13px;
  padding-bottom: 6px;
  width: 100%;
}

@media screen and (max-width: 480px) {
  .card-item__dateTitle {
    font-size: 12px;
    padding-bottom: 5px;
  }
}

.card-item__band {
  background: rgba(0, 0, 19, 0.8);
  width: 100%;
  height: 50px;
  margin-top: 30px;
  position: relative;
  z-index: 2;
}

@media screen and (max-width: 480px) {
  .card-item__band {
    margin-top: 20px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__band {
    height: 40px;
    margin-top: 10px;
  }
}

.card-item__cvv {
  text-align: right;
  position: relative;
  z-index: 2;
  padding: 15px;
}

.card-item__cvv .card-item__type {
  opacity: 0.7;
}

@media screen and (max-width: 360px) {
  .card-item__cvv {
    padding: 10px 15px;
  }
}

.card-item__cvvTitle {
  padding-right: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 5px;
}

.card-item__cvvBand {
  height: 45px;
  background: #fff;
  margin-bottom: 30px;
  text-align: right;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  padding-right: 10px;
  color: #1a3b5d;
  font-size: 18px;
  border-radius: 4px;
  -webkit-box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);
          box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);
}

@media screen and (max-width: 480px) {
  .card-item__cvvBand {
    height: 40px;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 360px) {
  .card-item__cvvBand {
    margin-bottom: 15px;
  }
}

.card-list {
  margin-bottom: -130px;
}

@media screen and (max-width: 480px) {
  .card-list {
    margin-bottom: -120px;
  }
}

@media screen and (max-width: 500px) {
  .img {
    margin-top: 0% !important;
  }
}

.card-input {
  margin-bottom: 20px;
}

.card-input__label {
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 500;
  color: #1a3b5d;
  width: 100%;
  display: block;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.card-input__input {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  -webkit-box-shadow: none;
          box-shadow: none;
  border: 1px solid #ced6e0;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  font-size: 18px;
  padding: 5px 15px;
  background: none;
  color: #1a3b5d;
  font-family: "Source Sans Pro", sans-serif;
}

.card-input__input:hover, .card-input__input:focus {
  border-color: #3d9cff;
}

.card-input__input:focus {
  -webkit-box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
          box-shadow: 0px 10px 20px -13px rgba(32, 56, 117, 0.35);
}

.card-input__input.-select {
  -webkit-appearance: none;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAeCAYAAABuUU38AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUxJREFUeNrM1sEJwkAQBdCsngXPHsQO9O5FS7AAMVYgdqAd2IGCDWgFnryLFQiCZ8EGnJUNimiyM/tnk4HNEAg/8y6ZmMRVqz9eUJvRaSbvutCZ347bXVJy/ZnvTmdJ862Me+hAbZCTs6GHpyUi1tTSvPnqTpoWZPUa7W7ncT3vK4h4zVejy8QzM3WhVUO8ykI6jOxoGA4ig3BLHcNFSCGqGAkig2yqgpEiMsjSfY9LxYQg7L6r0X6wS29YJiYQYecemY+wHrXD1+bklGhpAhBDeu/JfIVGxaAQ9sb8CI+CQSJ+QmJg0Ii/EE2MBiIXooHRQhRCkBhNhBcEhLkwf05ZCG8ICCOpk0MULmvDSY2M8UawIRExLIQIEgHDRoghihgRIgiigBEjgiFATBACAgFgghEwSAAGgoBCBBgYAg5hYKAIFYgHBo6w9RRgAFfy160QuV8NAAAAAElFTkSuQmCC");
  background-size: 12px;
  background-position: 90% center;
  background-repeat: no-repeat;
  padding-right: 30px;
}

.slide-fade-up-enter-active {
  -webkit-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
  -webkit-transition-delay: 0.1s;
          transition-delay: 0.1s;
  position: relative;
}

.slide-fade-up-leave-active {
  -webkit-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
  position: absolute;
}

.slide-fade-up-enter {
  opacity: 0;
  -webkit-transform: translateY(15px);
          transform: translateY(15px);
  pointer-events: none;
}

.slide-fade-up-leave-to {
  opacity: 0;
  -webkit-transform: translateY(-15px);
          transform: translateY(-15px);
  pointer-events: none;
}

.slide-fade-right-enter-active {
  -webkit-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
  -webkit-transition-delay: 0.1s;
          transition-delay: 0.1s;
  position: relative;
}

.slide-fade-right-leave-active {
  -webkit-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
  position: absolute;
}

.slide-fade-right-enter {
  opacity: 0;
  -webkit-transform: translateX(10px) rotate(45deg);
          transform: translateX(10px) rotate(45deg);
  pointer-events: none;
}

.slide-fade-right-leave-to {
  opacity: 0;
  -webkit-transform: translateX(-10px) rotate(45deg);
          transform: translateX(-10px) rotate(45deg);
  pointer-events: none;
}

.container-card {
  height: 500px;
}

.data {
  padding: 30px;
}

.photo {
  padding-bottom: 10px;
}

.img {
  border-radius: 12px;
  margin-top: 20%;
}

#houseData {
  padding-top: 5%;
}

#title {
  text-align: center;
}
.cost {
  color: #ff8500;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  width: 100%;
}

.house-item {
  width: 100%;
  text-align: center;
  color: #2e2e2e;
}
.reserve {
  font-size: 20px;
}

.cost strong {
  color: #2e2e2e;
  font-size: 16px;
  font-weight: bold;
}
.card-item__number {
  color: #fff !important;
}
</style>
